import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './globalStore';

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById('root'),
);

if (process.env.APP_ENV !== 'production') serviceWorker.unregister();
else serviceWorker.register({ scope: '/' });
